import { Row, Col, Table, Card } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import { HISTORY, DATE, MESSAGE, NOTES, MESSAGE_READ, YES, NO, STATUS } from "../../util/const";
import { ReviewContext } from "../ReviewPatient";
import { FormatDateForDisplay } from "../../util/data-utils";
import { LinkOffOutlined, LinkOutlined } from "@mui/icons-material";

const ReviewHistory = () =>
{
  const context = useContext(ReviewContext);

   const [history, setHistory] = useState(context.patient.reviews)

  useEffect(() => 
    {   
      setHistory(context.patient.reviews);
    }, [context.patient.reviews]); 

  return (
    <Row className="mt-3">
      <Col>
        <Card>
          <Card.Header className="fs-5">
            <Row>
              <Col>
                {HISTORY}:
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
          <Table bordered hover striped>
            <thead>
              <tr>
                <th className="small-col left">{DATE}</th>
                <th>{MESSAGE}</th>
                <th className="small-col centre">{MESSAGE_READ}</th>
                <th>{NOTES}</th>
                <th className="small-col centre">{STATUS}</th>
              </tr>
            </thead>
            <tbody>
              { (history !== undefined && history != null) ? history.map((element, i) => {
                  return (
                    <React.Fragment key={i}>
                      { (element.message!= null || element.note != null)?(
                      <tr>
                        <td className="small-col left">{FormatDateForDisplay(element.reviewDate)}</td>
                        <td>{element.message}</td>
                        <td className="small-col centre">{element.messageRead ? YES:NO}</td>
                        <td> {element.note}</td>
                        <td className="small-col centre"> {element.enteredInError ?<LinkOffOutlined color="warning"/>:<LinkOutlined color="success"/>}</td>
                      </tr>):<></>
                      }   
                    </React.Fragment>
                  )
                }) : <></>
              }
            </tbody>
          </Table>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}

export default ReviewHistory;